import React, { createContext, useState, useContext } from 'react';
import authService from '../api/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const storedUserDetails = localStorage.getItem('user_details');
        try {
            return storedUserDetails ? JSON.parse(storedUserDetails) : null;
        } catch (error) {
            console.error("Failed to parse user details from localStorage", error);
            return null;
        }
    });

    const login = async (username, password) => {
        try {
            const response = await authService.login(username, password);
            if (response.data.accessToken && response.data.refreshToken) {
                localStorage.setItem('accessToken', response.data.accessToken); // 액세스 토큰 저장
                localStorage.setItem('refreshToken', response.data.refreshToken); // 리프레시 토큰 저장

                const userDetails = {
                    username: response.data.username,
                    name: response.data.name, // name 추가
                    position: response.data.position, // position 추가
                    role: response.data.role // role도 포함 (필요하다면)
                };
                localStorage.setItem('user_details', JSON.stringify(userDetails));
                setUser(userDetails);
                return true;
            }
            return false;
        } catch (error) {
            console.error("Login failed", error);
            return false;
        }
    };

    const logout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user_details');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};